import styled from 'styled-components'

export const Page = styled.div`
  height: 100%;
  background-color: black;
  
  .headContainer {
    display: flex;
    flex-direction: row;
    
    .title {
      padding-left: 1rem;
    }
  }
  
  .navbar {
    position: relative !important;
  }
  
  .modal-center {
    display: flex;
    justify-content: center;
  }
  
  .hidden {
    display: none;
  }
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  
  .background {
    height: 100%;
    width: 100%;
    background-size: cover;
    opacity: 0.7;
    position: absolute;
    background-position: top;
  }

  .defaultMarket {
    background-image: url("images/market3_960x1713.png") !important;
  }

  .marketChicago {
    background-image: url("images/market1_960x1280.jpeg") !important;
  }

  .marketOntario {
    background-image: url("images/market2_960x1708.jpeg") !important;
  }

  .landingMobile {
    padding-top: env(safe-area-inset-top)
  }
  
  .marketMessaging {
    height: 100%;
    max-width: 30rem;
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: space-evenly;
    color: val(--primary-contrast);
    margin: 0;
    padding: 0 1.5rem;

    .screenTitle {
      color: white;
      display: flex;
      font-size: var(--typography-h4-size);
      font-style: normal;
      font-weight: 600;
      line-height: 123.5%; /* 41.99px */
      letter-spacing: 0.25px;
      margin-bottom: 1rem;
    }

    .screenDescription {
      color: white;
      font-feature-settings: 'clig' off, 'liga' off;
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 24px */
      letter-spacing: 0.15px;
      margin-bottom: 1rem;
    }
  }
`

